import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Match } from '../../../_shared/models/match.model';

interface DrawStage {
    name: string;
    value?: string;
}

interface Round {
    name: string;
    value?: string;
}

@Component({
  standalone: false,
    selector: 'app-round-name',
    templateUrl: './round-name.component.html',
    styleUrls: ['./round-name.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoundNameComponent implements OnInit {
    @Input({ required: true}) match: Match
    @Output() roundName: EventEmitter<string> = new EventEmitter();
    form: UntypedFormGroup;

    drawStages: DrawStage[] = [
        {
            name: 'Main',
            value: 'MAIN'
        },
        {
            name: 'Qualifying',
            value: 'QUALIFYING'
        }
    ];

    rounds: Round[] = [
        {
            name: 'Round 1',
            value: 'R1'
        },
        {
            name: 'Round 2',
            value: 'R2'
        },
        {
            name: 'Round 3',
            value: 'R3'
        },
        {
            name: 'Round 4',
            value: 'R4'
        },
        {
            name: 'Round 256',
            value: 'R256'
        },
        {
            name: 'Round 128',
            value: 'R128'
        },
        {
            name: 'Round 64',
            value: 'R64'
        },
        {
            name: 'Round 32',
            value: 'R32'
        },
        {
            name: 'Round 16',
            value: 'R16'
        },
        {
            name: '1/4 finals',
            value: 'QF'
        },
        {
            name: '1/2 finals',
            value: 'SF'
        },
        {
            name: 'Finals',
            value: 'F'
        },
    ];

    constructor(
        private fb: UntypedFormBuilder
    ) { }

    ngOnInit() {
        this.buildForm();
    }

    buildForm() {
        let roundName: string;
        let drawStage: string;

        if (this.match?.roundName) {
            if (this.match.roundName.includes('Q-')) {
                const splitRoundName = this.match.roundName.split('-')
                drawStage = 'QUALIFYING';
                roundName = splitRoundName[1];
            } else {
                drawStage = 'MAIN';
                roundName = this.match.roundName;
            }
        }

        this.form = this.fb.group({
            round: [roundName],
            drawStage: [drawStage]
        });

        this.emitRoundName();

        this.form.valueChanges
            .subscribe(
                () => {
                    this.emitRoundName();
                }
            );
    }

    emitRoundName() {
        let roundName = '';
        if (this.form.get('drawStage').value === 'QUALIFYING') {
            roundName += 'Q-';
        }

        roundName += this.form.get('round').value;
        this.roundName.emit(roundName);
    }



}
